export class Energy {
    public get kilojoules(): number {
        return this.joules * 1000;
    }

    public get calories(): number {
        return this.joules / 4.184;
    }

    public get kilocalories(): number {
        return this.calories / 1000;
    }

    constructor(public joules: number) {}

    public static fromJoules(joules: number): Energy {
        return new Energy(joules);
    }

    public static fromKilojoules(kilojoules: number): Energy {
        return new Energy(kilojoules / 1000);
    }

    static fromCalories(calories: number): Energy {
        return new Energy(calories * 4.184);
    }

    public add(other: Energy): Energy {
        return new Energy(this.joules + other.joules);
    }

    static average(...energies: Energy[]): Energy | null {
        if (energies.length === 0) {
            return null;
        }
        const totalJoules = energies.reduce((total, energy) => total + energy.joules, 0);
        return Energy.fromJoules(totalJoules / energies.length);
    }
}
